/**
 * Refill Service
 * API service for refill management operations
 */

import { apiClient } from './apiClient';

const RefillService = {
    /**
     * Search refills with filters and pagination
     * @param {Object} params - Search parameters
     * @returns {Promise<Object>} Search results with pagination
     */
    searchRefills: async (params = {}) => {
        const response = await apiClient.get('/refills', { params });
        return response.data;
    },

    /**
     * Get summary metrics for dashboard
     * @returns {Promise<Object>} Metrics data
     */
    getMetrics: async () => {
        const response = await apiClient.get('/refills/metrics');
        return response.data;
    },

    /**
     * Update refill status
     * @param {string} refillId - Refill ID (claimId_medicationIndex)
     * @param {Object} update - Status update data
     * @returns {Promise<Object>} Update result
     */
    updateStatus: async (refillId, update) => {
        const response = await apiClient.put(`/refills/${refillId}/status`, update);
        return response.data;
    },

    /**
     * Log a communication attempt
     * @param {string} refillId - Refill ID
     * @param {Object} logData - Communication log data
     * @returns {Promise<Object>} Log result
     */
    logCommunication: async (refillId, logData) => {
        const response = await apiClient.post(`/refills/${refillId}/communication`, logData);
        return response.data;
    },

    /**
     * Resolve a refill request
     * @param {string} refillId - Refill ID
     * @param {string} reason - Resolution reason
     * @param {string} notes - Optional notes
     * @returns {Promise<Object>} Resolution result
     */
    resolveRefill: async (refillId, reason, notes) => {
        const response = await apiClient.post(`/refills/${refillId}/resolve`, { reason, notes });
        return response.data;
    },

    /**
     * Get communication history for a refill
     * @param {string} refillId - Refill ID
     * @returns {Promise<Object>} History data
     */
    getCommunicationHistory: async (refillId) => {
        const response = await apiClient.get(`/refills/${refillId}/history`);
        return response.data;
    }
};

export default RefillService;
